import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M5 20H9.08V22H5C3.9 22 3 21.1 3 20V4C3 2.9 3.9 2 5 2H9.01V4H5V20ZM14.76 5.75L13.34 7.17L17.15 10.99H8.04V13H17.15L13.34 16.82L14.76 18.24L21 11.99L14.76 5.74V5.75Z" fill={ fill || 'currentColor' } />
    </svg>
);
